<template>
     <div id="echart-bar" :style="{width: '100%', height: '100%'} "></div>   
</template>

<script>


export default({
    props:{
        barData:Array,
        barTitle:String,
    },
    data(){
        return{
            barName:[]
        }
    },
    watch:{
        barData:function(){
            this.initChart()
        }
    },
    mounted(){
        this.initChart()
    },
    methods: {
        initChart() {  
            this.barName=[]
            for (let i = 0; i < this.barData.length; i++) {
                this.barName[i] = this.barData[i].name;
            }
            this.barChart = this.echarts.init(document.getElementById("echart-bar"));
            const option = {
                legend: false,
                title: { 
                    text: this.barTitle,
                    top: "0%",
                    left: "center",
                    textStyle: {
                        "fontSize": 15
                    }
                },
                grid: {
                    // 四周留白区域设置
                    left: '10%',
                    right:'10%',
                    bottom:'0%',
                    top:'15%',
                    containLabel: true,
                },
                xAxis:{
                    type:'value',
                    data:this.barData,
                    axisLabel:{
                        interval:0 // 0：强制显示所有标签 1：隔一个标签显示一个
                    },
                      axisTick: {
                        show: false
                    },
                },
                yAxis:{
                    type:'category',
                    data:this.barName,
                    axisLabel: {
                    show: true
                    },
                    axisTick: {
                        show: false
                    },
                },
                series: [{
                    type: "bar",
                    label: {
                        show: true,
                        position: 'right',
                        formatter:function(p){
                            if (!p.value && p.value !== 0) return 0;
                            let str = p.value.toString();
                            let reg =
                                str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
                            return str.replace(reg, "$1,");
                        },
                    },
                    
                    itemStyle: {
                        normal: {
                            color: function (params) {
                                // build a color map as your need.
                                var colorList = [
                                    'rgb(238,102,104)','rgb(165,218,84)','rgb(251,241,123)','rgb(130,204,232)',
                                    'rgb(255,209,3)','rgb(174,160,217)','rgb(10,146,40)','rgb(255,187,1)'
                                ];
                                return colorList[params.dataIndex]
                            },
                        }
                    },
                    data: this.barData
                }],
                tooltip: {
                    trigger: 'item',
                    formatter:function(p){
                            if (!p.value && p.value !== 0) return 0;
                            let str = p.value.toString();
                            let reg = str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
                            return p.name+":"+str.replace(reg, "$1,");
                        },
                    position: ['50%', '50%']
                },
            };
            this.barChart.setOption(option);
            //随着屏幕大小调节图表
            window.onresize = this.barChart.resize();
        }
    }
})
</script>
